import Shadow from './Shadow';

export { Shadow };



// WEBPACK FOOTER //
// ./src/baseComponents/directives/Shadow/index.js